<template lang="pug">
    section.abonement
        //- document-template-field.grow.document-template-field(
        //-     v-if="options.documentTemplatePartial.items.length"
        //-     :field="{ type: 'code-editor:css', template: options.documentTemplatePartial.items[0].value }"
        //- )
        el-row
            el-collapse(accordion v-if="blocks && blocks.length")
                transition-group(name="slide-decent-vertical")
                    el-collapse-item(
                        v-for="block in blocks" :key="block.key"
                        v-if="checkConditions(block)"
                        :name="block.key"
                    )
                        template(slot="title")
                            FontAwesomeIcon.icon(v-if="block.icon" :icon="block.icon")
                            span {{ block.name }}
                        transition-group(name="slide-decent-vertical")
                            .row(
                                v-for="(group, i) in block.groups" :key="i"
                                v-if="checkConditions(group)"
                            )
                                transition-group.flex(name="slide-decent-vertical")
                                    SettingField.setting-field(
                                        v-for="field in group.fields"
                                        v-if="checkConditions(field)"
                                        :key="field.key"
                                        :field="field"
                                        :setting-values="settingValues"
                                    )
        el-row(v-if="documentTemplates && documentTemplates.length")
            el-collapse(accordion v-if="documentTemplates && documentTemplates.length")
                el-collapse-item(
                    v-for="documentTemplate in documentTemplates" :key="documentTemplate.key"
                    :name="documentTemplate.key"
                )
                    template(slot="title")
                        FontAwesomeIcon.icon(v-if="documentTemplate.icon" :icon="documentTemplate.icon")
                        span {{ $t(documentTemplate.name) }}
                    .accordion-body
                        .alert.info(v-if="documentTemplate.info") {{ $t(documentTemplate.info) }}
                        template(v-for="field in documentTemplate.fields")
                            template(v-if="field.type === 'divider'")
                                .flex-row.gap-sm.justify-center.align-center
                                    hr.wave.grow.no-margin
                                    strong.name {{ $t(field.name) }}
                                    hr.wave.grow.no-margin
                            template(v-else)
                                //- :key="`${field.key}-disabled-${field.disabled}`"
                                document-template-field.grow.document-template-field(
                                    :key="field.key"
                                    :field="field"
                                    :disabled="field.disabled"
                                    @input="value => updateDocumentTemplatePartial({ key: field.key, template: value })"
                                    @click.native="field.disabled ? toggleDefault(false, field) : null"
                                )
                                el-form-item
                                    el-switch(
                                        :value="field.disabled"
                                        :active-text="$t('Use default {type}', { type: field.name })"
                                        @change="value => toggleDefault(value, field)"
                                    )
        template(v-else)
            .alert.warning {{ $t('No document templates available') }}
</template>

<i18n>
{
    "en": {
        "Use default {type}": "Use default {type}"
    },
    "de": {
        "No document templates available": "Keine Dokumentvorlagen verfügbar",
        "Use default {type}": "Standard {type} verwenden",
        "Letters": "Briefe",
        "Emails": "E-Mails",
        "Header": "Kopfzeile",
        "Letter Head": "Briefkopf",
        "Body": "Hauptteil",
        "Footer": "Fußzeile",
        "CSS": "CSS",

        "PDF Letter Head": "PDF Briefkopf",
        "PDF CSS": "PDF CSS",
        "PDF Body": "PDF Hauptteil",
        "PDF Footer": "PDF Fußzeile",
        "PDF Articles Table": "PDF Artikeltabelle",
        "PDF Summary": "PDF Zusammenfassung",

        "Email Header": "E-Mail Kopfzeile",
        "Email CSS": "E-Mail CSS",
        "Email Body": "E-Mail Hauptteil",
        "Email Footer": "E-Mail Fußzeile",
        "Email Customer Address": "E-Mail Kundenadresse",
        "Email Articles Table": "E-Mail Artikeltabelle",
        "Email Summary": "E-Mail Zusammenfassung",

        "Purchase Macros": "Bestellung Makros",
        "Articles Table": "Artikeltabelle",
        "Summary": "Zusammenfassung",
        "Delivery Note": "Lieferschein",
        "Delivery Note Macros": "Lieferschein Makros",
        "Packing List": "Packliste",
        "Packing List Macros": "Packliste Makros",
        "Stock Report": "Bestandsliste",
        "Stock Report Macros": "Bestandsliste Makros",
        "POS Cash Report": "Kassenabschluss",
        "POS Cash Report Macros": "Kassenabschluss Makros",
        "Inventory Protocol": "Inventur-Protokoll",
        "Inventory Protocol Macros": "Inventur-Protokoll Makros",
        "Logs Table": "Protokolltabelle",
        "Purchase confirmation": "Bestellbestätigung",
        "Invoice": "Rechnung",
        "Credit Note": "Gutschrift",
        "Coupon": "Gutschein",
        "Reset Password": "Passwort zurücksetzen"
    }
}
</i18n>

<script>

import _ from 'lodash'
import store from '@/store'
import { mapGetters, mapMutations } from 'vuex'

import SettingField from './Partials/SettingField'
import DocumentTemplateField from './Partials/DocumentTemplateField'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'AbonementDocumentTemplates',
    components: {
        SettingField,
        FontAwesomeIcon,
        DocumentTemplateField
    },
    computed: {
        settings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            return settings.find(el => el.key === 'document-templates')
        },
        blocks() {
            return _.get(this.settings, 'blocks') || []
        },
        documentTemplates() {
            let templates = []

            // make assoc object
            const defaults = this.options.documentTemplatePartial.items.reduce((acc, el) => {
                acc[el.key] = el.value
                return acc
            }, {})

            // make assoc object
            const overrides = this.form.documentTemplatePartials.reduce((acc, el) => {
                acc[el.key] = el.template
                return acc
            }, {})

            // handle email partials

            const emailStyle = _.get(overrides, 'email:style')
            const emailHeaderPartial = _.get(overrides, 'email:header')
            const emailFooterPartial = _.get(overrides, 'email:footer')

            const email = {
                style: {
                    partial: emailStyle,
                    default: _.get(defaults, 'email:style', '').trim(),
                },
                header: {
                    partial: emailHeaderPartial,
                    default: _.get(defaults, 'email:header', '').trim(),
                },
                footer: {
                    partial: emailFooterPartial,
                    default: _.get(defaults, 'email:footer', '').trim(),
                }
            }

            templates.push({
                key: 'email',
                name: 'Emails',
                icon: 'fa-solid fa-at',
                fields: [
                    {
                        key: 'email:style',
                        name: this.$t('CSS'),
                        type: 'code-editor:css',
                        disabled: email.style.partial !== undefined ? false : true,
                        default: email.style.default,
                        template: email.style.partial !== undefined ? email.style.partial : email.style.default,
                    },
                    {
                        key: 'email:header',
                        name: this.$t('Header'),
                        type: 'code-editor:twig',
                        disabled: email.header.partial !== undefined ? false : true,
                        default: email.header.default,
                        template: email.header.partial !== undefined ? email.header.partial : email.header.default,
                    },
                    {
                        key: 'email:footer',
                        name: this.$t('Footer'),
                        type: 'code-editor:twig',
                        disabled: email.footer.partial !== undefined ? false : true,
                        default: email.footer.default,
                        template: email.footer.partial !== undefined ? email.footer.partial : email.footer.default,
                    }
                ]
            })

            // handle letter partials

            const letterStyle = _.get(overrides, 'pdf-letter:style')
            const letterHeaderPartial = _.get(overrides, 'pdf-letter:header')
            const letterFooterPartial = _.get(overrides, 'pdf-letter:footer')

            const letter = {
                style: {
                    partial: letterStyle,
                    default: _.get(defaults, 'pdf-letter:style', '').trim(),
                },
                header: {
                    partial: letterHeaderPartial,
                    default: _.get(defaults, 'pdf-letter:header', '').trim(),
                },
                footer: {
                    partial: letterFooterPartial,
                    default: _.get(defaults, 'pdf-letter:footer', '').trim(),
                }
            }

            templates.push({
                key: 'pdf-letter',
                name: 'Letters',
                icon: 'fa-solid fa-envelope-open-text',
                fields: [
                    {
                        key: 'pdf-letter:style',
                        name: this.$t('CSS'),
                        type: 'code-editor:css',
                        disabled: letter.style.partial !== undefined ? false : true,
                        default: letter.style.default,
                        template: letter.style.partial !== undefined ? letter.style.partial : letter.style.default,
                    },
                    {
                        key: 'pdf-letter:header',
                        name: this.$t('Letter Head'),
                        type: 'code-editor:twig',
                        disabled: letter.header.partial !== undefined ? false : true,
                        default: letter.header.default,
                        template: letter.header.partial !== undefined ? letter.header.partial : letter.header.default,
                    },
                    {
                        key: 'pdf-letter:footer',
                        name: this.$t('Footer'),
                        type: 'code-editor:twig',
                        disabled: letter.footer.partial !== undefined ? false : true,
                        default: letter.footer.default,
                        template: letter.footer.partial !== undefined ? letter.footer.partial : letter.footer.default,
                    }
                ]
            })

            // handle purchase partials

            if (this.form.extensions.find(extension => extension.key === 'shop')) {

                // purchase confirmation

                // inherit from email

                defaults['purchase-confirmation-email:header'] = defaults['email:header']
                if (emailHeaderPartial) defaults['purchase-confirmation-email:header'] = emailHeaderPartial

                defaults['purchase-confirmation-email:footer'] = defaults['email:footer']
                if (emailFooterPartial) defaults['purchase-confirmation-email:footer'] = emailFooterPartial

                // inherit from letter

                defaults['purchase-confirmation-pdf:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['purchase-confirmation-pdf:header'] = letterHeaderPartial

                defaults['purchase-confirmation-pdf:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['purchase-confirmation-pdf:footer'] = letterFooterPartial

                const purchaseConfirmation = {
                    email: {
                        style: {
                            partial: _.get(overrides, 'purchase-confirmation-email:style'),
                            default: _.get(defaults, 'purchase-confirmation-email:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'purchase-confirmation-email:header'),
                            default: _.get(defaults, 'purchase-confirmation-email:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'purchase-confirmation-email:body'),
                            default: _.get(defaults, 'purchase-confirmation-email:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'purchase-confirmation-email:footer'),
                            default: _.get(defaults, 'purchase-confirmation-email:footer', '').trim(),
                        }
                    },
                    pdf: {
                        style: {
                            partial: _.get(overrides, 'purchase-confirmation-pdf:style'),
                            default: _.get(defaults, 'purchase-confirmation-pdf:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'purchase-confirmation-pdf:header'),
                            default: _.get(defaults, 'purchase-confirmation-pdf:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'purchase-confirmation-pdf:body'),
                            default: _.get(defaults, 'purchase-confirmation-pdf:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'purchase-confirmation-pdf:footer'),
                            default: _.get(defaults, 'purchase-confirmation-pdf:footer', '').trim(),
                        }
                    }
                }

                templates.push({
                    key: 'purchase-confirmation',
                    name: 'Purchase confirmation',
                    icon: 'fa-solid fa-file-invoice',
                    fields: [
                        {
                            key: 'purchase-confirmation-email:style',
                            name: this.$t('Email CSS'),
                            type: 'code-editor:css',
                            disabled: purchaseConfirmation.email.style.partial !== undefined ? false : true,
                            default: purchaseConfirmation.email.style.default,
                            template: purchaseConfirmation.email.style.partial !== undefined
                                ? purchaseConfirmation.email.style.partial
                                : purchaseConfirmation.email.style.default,
                        },
                        {
                            key: 'purchase-confirmation-email:header',
                            name: this.$t('Email Header'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.email.header.partial !== undefined ? false : true,
                            default: purchaseConfirmation.email.header.default,
                            template: purchaseConfirmation.email.header.partial !== undefined
                                ? purchaseConfirmation.email.header.partial
                                : purchaseConfirmation.email.header.default,
                        },
                        {
                            key: 'purchase-confirmation-email:body',
                            name: this.$t('Email Body'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.email.body.partial !== undefined ? false : true,
                            default: purchaseConfirmation.email.body.default,
                            template: purchaseConfirmation.email.body.partial !== undefined
                                ? purchaseConfirmation.email.body.partial
                                : purchaseConfirmation.email.body.default,
                        },
                        {
                            key: 'purchase-confirmation-email:footer',
                            name: this.$t('Email Footer'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.email.footer.partial !== undefined ? false : true,
                            default: purchaseConfirmation.email.footer.default,
                            template: purchaseConfirmation.email.footer.partial !== undefined
                                ? purchaseConfirmation.email.footer.partial
                                : purchaseConfirmation.email.footer.default,
                        },
                        {
                            key: 'purchase-confirmation-pdf:divider',
                            name: this.$t('PDF'),
                            type: 'divider',
                        },
                        {
                            key: 'purchase-confirmation-pdf:style',
                            name: this.$t('PDF CSS'),
                            type: 'code-editor:css',
                            disabled: purchaseConfirmation.pdf.style.partial !== undefined ? false : true,
                            default: purchaseConfirmation.pdf.style.default,
                            template: purchaseConfirmation.pdf.style.partial !== undefined
                                ? purchaseConfirmation.pdf.style.partial
                                : purchaseConfirmation.pdf.style.default,
                        },
                        {
                            key: 'purchase-confirmation-pdf:header',
                            name: this.$t('PDF Letter Head'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.pdf.header.partial !== undefined ? false : true,
                            default: purchaseConfirmation.pdf.header.default,
                            template: purchaseConfirmation.pdf.header.partial !== undefined
                                ? purchaseConfirmation.pdf.header.partial
                                : purchaseConfirmation.pdf.header.default,
                        },
                        {
                            key: 'purchase-confirmation-pdf:body',
                            name: this.$t('PDF Body'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.pdf.body.partial !== undefined ? false : true,
                            default: purchaseConfirmation.pdf.body.default,
                            template: purchaseConfirmation.pdf.body.partial !== undefined
                                ? purchaseConfirmation.pdf.body.partial
                                : purchaseConfirmation.pdf.body.default,
                        },
                        {
                            key: 'purchase-confirmation-pdf:footer',
                            name: this.$t('PDF Footer'),
                            type: 'code-editor:twig',
                            disabled: purchaseConfirmation.pdf.footer.partial !== undefined ? false : true,
                            default: purchaseConfirmation.pdf.footer.default,
                            template: purchaseConfirmation.pdf.footer.partial !== undefined
                                ? purchaseConfirmation.pdf.footer.partial
                                : purchaseConfirmation.pdf.footer.default,
                        }
                    ]
                })

                // invoice

                // inherit from email

                defaults['invoice-email:header'] = defaults['email:header']
                if (emailHeaderPartial) defaults['invoice-email:header'] = emailHeaderPartial

                defaults['invoice-email:footer'] = defaults['email:footer']
                if (emailFooterPartial) defaults['invoice-email:footer'] = emailFooterPartial

                // inherit from letter

                defaults['invoice-pdf:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['invoice-pdf:header'] = letterHeaderPartial

                defaults['invoice-pdf:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['invoice-pdf:footer'] = letterFooterPartial

                const invoice = {
                    email: {
                        style: {
                            partial: _.get(overrides, 'invoice-email:style'),
                            default: _.get(defaults, 'invoice-email:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'invoice-email:header'),
                            default: _.get(defaults, 'invoice-email:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'invoice-email:body'),
                            default: _.get(defaults, 'invoice-email:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'invoice-email:footer'),
                            default: _.get(defaults, 'invoice-email:footer', '').trim(),
                        }
                    },
                    pdf: {
                        style: {
                            partial: _.get(overrides, 'invoice-pdf:style'),
                            default: _.get(defaults, 'invoice-pdf:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'invoice-pdf:header'),
                            default: _.get(defaults, 'invoice-pdf:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'invoice-pdf:body'),
                            default: _.get(defaults, 'invoice-pdf:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'invoice-pdf:footer'),
                            default: _.get(defaults, 'invoice-pdf:footer', '').trim(),
                        }
                    }
                }

                templates.push({
                    key: 'invoice-pdf',
                    name: 'Invoice',
                    icon: 'fa-solid fa-file-invoice-dollar',
                    fields: [
                        {
                            key: 'invoice-email:style',
                            name: this.$t('Email CSS'),
                            type: 'code-editor:css',
                            disabled: invoice.email.style.partial !== undefined ? false : true,
                            default: invoice.email.style.default,
                            template: invoice.email.style.partial !== undefined
                                ? invoice.email.style.partial
                                : invoice.email.style.default,
                        },
                        {
                            key: 'invoice-email:header',
                            name: this.$t('Email Header'),
                            type: 'code-editor:twig',
                            disabled: invoice.email.header.partial !== undefined ? false : true,
                            default: invoice.email.header.default,
                            template: invoice.email.header.partial !== undefined
                                ? invoice.email.header.partial
                                : invoice.email.header.default,
                        },
                        {
                            key: 'invoice-email:body',
                            name: this.$t('Email Body'),
                            type: 'code-editor:twig',
                            disabled: invoice.email.body.partial !== undefined ? false : true,
                            default: invoice.email.body.default,
                            template: invoice.email.body.partial !== undefined
                                ? invoice.email.body.partial
                                : invoice.email.body.default,
                        },
                        {
                            key: 'invoice-email:footer',
                            name: this.$t('Email Footer'),
                            type: 'code-editor:twig',
                            disabled: invoice.email.footer.partial !== undefined ? false : true,
                            default: invoice.email.footer.default,
                            template: invoice.email.footer.partial !== undefined
                                ? invoice.email.footer.partial
                                : invoice.email.footer.default,
                        },
                        {
                            key: 'invoice-pdf:divider',
                            name: this.$t('PDF'),
                            type: 'divider',
                        },
                        {
                            key: 'invoice-pdf:style',
                            name: this.$t('PDF CSS'),
                            type: 'code-editor:css',
                            disabled: invoice.pdf.style.partial !== undefined ? false : true,
                            default: invoice.pdf.style.default,
                            template: invoice.pdf.style.partial !== undefined
                                ? invoice.pdf.style.partial
                                : invoice.pdf.style.default,
                        },
                        {
                            key: 'invoice-pdf:header',
                            name: this.$t('PDF Letter Head'),
                            type: 'code-editor:twig',
                            disabled: invoice.pdf.header.partial !== undefined ? false : true,
                            default: invoice.pdf.header.default,
                            template: invoice.pdf.header.partial !== undefined
                                ? invoice.pdf.header.partial
                                : invoice.pdf.header.default,
                        },
                        {
                            key: 'invoice-pdf:body',
                            name: this.$t('PDF Body'),
                            type: 'code-editor:twig',
                            disabled: invoice.pdf.body.partial !== undefined ? false : true,
                            default: invoice.pdf.body.default,
                            template: invoice.pdf.body.partial !== undefined
                                ? invoice.pdf.body.partial
                                : invoice.pdf.body.default,
                        },
                        {
                            key: 'invoice-pdf:footer',
                            name: this.$t('PDF Footer'),
                            type: 'code-editor:twig',
                            disabled: invoice.pdf.footer.partial !== undefined ? false : true,
                            default: invoice.pdf.footer.default,
                            template: invoice.pdf.footer.partial !== undefined
                                ? invoice.pdf.footer.partial
                                : invoice.pdf.footer.default,
                        }
                    ]
                })

                // credit note

                // inherit from email

                defaults['credit-note-email:header'] = defaults['email:header']
                if (emailHeaderPartial) defaults['credit-note-email:header'] = emailHeaderPartial

                defaults['credit-note-email:footer'] = defaults['email:footer']
                if (emailFooterPartial) defaults['credit-note-email:footer'] = emailFooterPartial

                // inherit from letter

                defaults['credit-note-pdf:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['credit-note-pdf:header'] = letterHeaderPartial

                defaults['credit-note-pdf:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['credit-note-pdf:footer'] = letterFooterPartial

                const creditNote = {
                    email: {
                        style: {
                            partial: _.get(overrides, 'credit-note-email:style'),
                            default: _.get(defaults, 'credit-note-email:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'credit-note-email:header'),
                            default: _.get(defaults, 'credit-note-email:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'credit-note-email:body'),
                            default: _.get(defaults, 'credit-note-email:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'credit-note-email:footer'),
                            default: _.get(defaults, 'credit-note-email:footer', '').trim(),
                        }
                    },
                    pdf: {
                        style: {
                            partial: _.get(overrides, 'credit-note-pdf:style'),
                            default: _.get(defaults, 'credit-note-pdf:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'credit-note-pdf:header'),
                            default: _.get(defaults, 'credit-note-pdf:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'credit-note-pdf:body'),
                            default: _.get(defaults, 'credit-note-pdf:body', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'credit-note-pdf:footer'),
                            default: _.get(defaults, 'credit-note-pdf:footer', '').trim(),
                        }
                    }
                }

                templates.push({
                    key: 'credit-note-pdf',
                    name: 'Credit Note',
                    icon: 'fa-solid fa-file-invoice-dollar',
                    fields: [
                        {
                            key: 'credit-note-email:style',
                            name: this.$t('Email CSS'),
                            type: 'code-editor:css',
                            disabled: creditNote.email.style.partial !== undefined ? false : true,
                            default: creditNote.email.style.default,
                            template: creditNote.email.style.partial !== undefined
                                ? creditNote.email.style.partial
                                : creditNote.email.style.default,
                        },
                        {
                            key: 'credit-note-email:header',
                            name: this.$t('Email Header'),
                            type: 'code-editor:twig',
                            disabled: creditNote.email.header.partial !== undefined ? false : true,
                            default: creditNote.email.header.default,
                            template: creditNote.email.header.partial !== undefined
                                ? creditNote.email.header.partial
                                : creditNote.email.header.default,
                        },
                        {
                            key: 'credit-note-email:body',
                            name: this.$t('Email Body'),
                            type: 'code-editor:twig',
                            disabled: creditNote.email.body.partial !== undefined ? false : true,
                            default: creditNote.email.body.default,
                            template: creditNote.email.body.partial !== undefined
                                ? creditNote.email.body.partial
                                : creditNote.email.body.default,
                        },
                        {
                            key: 'credit-note-email:footer',
                            name: this.$t('Email Footer'),
                            type: 'code-editor:twig',
                            disabled: creditNote.email.footer.partial !== undefined ? false : true,
                            default: creditNote.email.footer.default,
                            template: creditNote.email.footer.partial !== undefined
                                ? creditNote.email.footer.partial
                                : creditNote.email.footer.default,
                        },
                        {
                            key: 'credit-note-pdf:divider',
                            name: this.$t('PDF'),
                            type: 'divider',
                        },
                        {
                            key: 'credit-note-pdf:style',
                            name: this.$t('PDF CSS'),
                            type: 'code-editor:css',
                            disabled: creditNote.pdf.style.partial !== undefined ? false : true,
                            default: creditNote.pdf.style.default,
                            template: creditNote.pdf.style.partial !== undefined
                                ? creditNote.pdf.style.partial
                                : creditNote.pdf.style.default,
                        },
                        {
                            key: 'credit-note-pdf:header',
                            name: this.$t('PDF Letter Head'),
                            type: 'code-editor:twig',
                            disabled: creditNote.pdf.header.partial !== undefined ? false : true,
                            default: creditNote.pdf.header.default,
                            template: creditNote.pdf.header.partial !== undefined
                                ? creditNote.pdf.header.partial
                                : creditNote.pdf.header.default,
                        },
                        {
                            key: 'credit-note-pdf:body',
                            name: this.$t('PDF Body'),
                            type: 'code-editor:twig',
                            disabled: creditNote.pdf.body.partial !== undefined ? false : true,
                            default: creditNote.pdf.body.default,
                            template: creditNote.pdf.body.partial !== undefined
                                ? creditNote.pdf.body.partial
                                : creditNote.pdf.body.default,
                        },
                        {
                            key: 'credit-note-pdf:footer',
                            name: this.$t('PDF Footer'),
                            type: 'code-editor:twig',
                            disabled: creditNote.pdf.footer.partial !== undefined ? false : true,
                            default: creditNote.pdf.footer.default,
                            template: creditNote.pdf.footer.partial !== undefined
                                ? creditNote.pdf.footer.partial
                                : creditNote.pdf.footer.default,
                        }
                    ]
                })

                // purchase macros

                const purchase = {
                    email: {
                        customerAddress: {
                            partial: _.get(overrides, 'purchase-email:customer-address'),
                            default: _.get(defaults, 'purchase-email:customer-address', '').trim(),
                        },
                        articles: {
                            partial: _.get(overrides, 'purchase-email:articles'),
                            default: _.get(defaults, 'purchase-email:articles', '').trim(),
                        },
                        summary: {
                            partial: _.get(overrides, 'purchase-email:summary'),
                            default: _.get(defaults, 'purchase-email:summary', '').trim(),
                        }
                    },
                    pdf: {
                        articles: {
                            partial: _.get(overrides, 'purchase-pdf:articles'),
                            default: _.get(defaults, 'purchase-pdf:articles', '').trim(),
                        },
                        summary: {
                            partial: _.get(overrides, 'purchase-pdf:summary'),
                            default: _.get(defaults, 'purchase-pdf:summary', '').trim(),
                        }
                    }
                }

                templates.push({
                    key: 'purchase-pdf',
                    name: 'Purchase Macros',
                    icon: 'fa-solid fa-clone',
                    fields: [
                        {
                            key: 'purchase-email:customer-address',
                            name: this.$t('Email Customer Address'),
                            type: 'code-editor:twig',
                            disabled: purchase.email.customerAddress.partial !== undefined ? false : true,
                            default: purchase.email.customerAddress.default,
                            template: purchase.email.customerAddress.partial !== undefined
                                ? purchase.email.customerAddress.partial
                                : purchase.email.customerAddress.default,
                        },
                        {
                            key: 'purchase-email:articles',
                            name: this.$t('Email Articles Table'),
                            type: 'code-editor:twig',
                            disabled: purchase.email.articles.partial !== undefined ? false : true,
                            default: purchase.email.articles.default,
                            template: purchase.email.articles.partial !== undefined
                                ? purchase.email.articles.partial
                                : purchase.email.articles.default,
                        },
                        {
                            key: 'purchase-email:summary',
                            name: this.$t('Email Summary'),
                            type: 'code-editor:twig',
                            disabled: purchase.email.summary.partial !== undefined ? false : true,
                            default: purchase.email.summary.default,
                            template: purchase.email.summary.partial !== undefined
                                ? purchase.email.summary.partial
                                : purchase.email.summary.default,
                        },
                        {
                            key: 'purchase-pdf:divider',
                            name: this.$t('PDF'),
                            type: 'divider',
                        },
                        {
                            key: 'purchase-pdf:articles',
                            name: this.$t('PDF Articles Table'),
                            type: 'code-editor:twig',
                            disabled: purchase.pdf.articles.partial !== undefined ? false : true,
                            default: purchase.pdf.articles.default,
                            template: purchase.pdf.articles.partial !== undefined
                                ? purchase.pdf.articles.partial
                                : purchase.pdf.articles.default,
                        },
                        {
                            key: 'purchase-pdf:summary',
                            name: this.$t('PDF Summary'),
                            type: 'code-editor:twig',
                            disabled: purchase.pdf.summary.partial !== undefined ? false : true,
                            default: purchase.pdf.summary.default,
                            template: purchase.pdf.summary.partial !== undefined
                                ? purchase.pdf.summary.partial
                                : purchase.pdf.summary.default,
                        },
                    ]
                })

                // delivery note

                defaults['delivery-note:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['delivery-note:header'] = letterHeaderPartial

                defaults['delivery-note:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['delivery-note:footer'] = letterFooterPartial

                const deliveryNote = {
                    style: {
                        partial: _.get(overrides, 'delivery-note:style'),
                        default: _.get(defaults, 'delivery-note:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'delivery-note:header'),
                        default: _.get(defaults, 'delivery-note:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'delivery-note:body'),
                        default: _.get(defaults, 'delivery-note:body', '').trim(),
                    },
                    articles: {
                        partial: _.get(overrides, 'delivery-note:articles'),
                        default: _.get(defaults, 'delivery-note:articles', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'delivery-note:footer'),
                        default: _.get(defaults, 'delivery-note:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'delivery-note',
                    name: 'Delivery Note',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'delivery-note:style',
                            name: this.$t('CSS'),
                            type: 'code-editor:css',
                            disabled: deliveryNote.style.partial !== undefined ? false : true,
                            default: deliveryNote.style.default,
                            template: deliveryNote.style.partial !== undefined
                                ? deliveryNote.style.partial
                                : deliveryNote.style.default,
                        },
                        {
                            key: 'delivery-note:header',
                            name: this.$t('Letter Head'),
                            type: 'code-editor:twig',
                            disabled: deliveryNote.header.partial !== undefined ? false : true,
                            default: deliveryNote.header.default,
                            template: deliveryNote.header.partial !== undefined
                                ? deliveryNote.header.partial
                                : deliveryNote.header.default,
                        },
                        {
                            key: 'delivery-note:body',
                            name: this.$t('Body'),
                            type: 'code-editor:twig',
                            disabled: deliveryNote.body.partial !== undefined ? false : true,
                            default: deliveryNote.body.default,
                            template: deliveryNote.body.partial !== undefined
                                ? deliveryNote.body.partial
                                : deliveryNote.body.default,
                        },
                        {
                            key: 'delivery-note:footer',
                            name: this.$t('Footer'),
                            type: 'code-editor:twig',
                            disabled: deliveryNote.footer.partial !== undefined ? false : true,
                            default: deliveryNote.footer.default,
                            template: deliveryNote.footer.partial !== undefined
                                ? deliveryNote.footer.partial
                                : deliveryNote.footer.default,
                        }
                    ]
                })

                // delivery notes macros

                templates.push({
                    key: 'delivery-note-macros',
                    name: 'Delivery Note Macros',
                    icon: 'fa-solid fa-clone',
                    fields: [
                        {
                            key: 'delivery-note:articles',
                            name: this.$t('Articles Table'),
                            type: 'code-editor:twig',
                            disabled: deliveryNote.articles.partial !== undefined ? false : true,
                            default: deliveryNote.articles.default,
                            template: deliveryNote.articles.partial !== undefined
                                ? deliveryNote.articles.partial
                                : deliveryNote.articles.default,
                        },
                    ]
                })

                // packing list

                defaults['shipping-package-slip:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['shipping-package-slip:header'] = letterHeaderPartial

                defaults['shipping-package-slip:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['shipping-package-slip:footer'] = letterFooterPartial

                const shippingPackageSlip = {
                    style: {
                        partial: _.get(overrides, 'shipping-package-slip:style'),
                        default: _.get(defaults, 'shipping-package-slip:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'shipping-package-slip:header'),
                        default: _.get(defaults, 'shipping-package-slip:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'shipping-package-slip:body'),
                        default: _.get(defaults, 'shipping-package-slip:body', '').trim(),
                    },
                    articles: {
                        partial: _.get(overrides, 'shipping-package-slip:articles'),
                        default: _.get(defaults, 'shipping-package-slip:articles', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'shipping-package-slip:footer'),
                        default: _.get(defaults, 'shipping-package-slip:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'shipping-package-slip',
                    name: 'Packing List',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'shipping-package-slip:style',
                            name: this.$t('CSS'),
                            type: 'code-editor:css',
                            disabled: shippingPackageSlip.style.partial !== undefined ? false : true,
                            default: shippingPackageSlip.style.default,
                            template: shippingPackageSlip.style.partial !== undefined
                                ? shippingPackageSlip.style.partial
                                : shippingPackageSlip.style.default,
                        },
                        {
                            key: 'shipping-package-slip:header',
                            name: this.$t('Letter Head'),
                            type: 'code-editor:twig',
                            disabled: shippingPackageSlip.header.partial !== undefined ? false : true,
                            default: shippingPackageSlip.header.default,
                            template: shippingPackageSlip.header.partial !== undefined
                                ? shippingPackageSlip.header.partial
                                : shippingPackageSlip.header.default,
                        },
                        {
                            key: 'shipping-package-slip:body',
                            name: this.$t('Body'),
                            type: 'code-editor:twig',
                            disabled: shippingPackageSlip.body.partial !== undefined ? false : true,
                            default: shippingPackageSlip.body.default,
                            template: shippingPackageSlip.body.partial !== undefined
                                ? shippingPackageSlip.body.partial
                                : shippingPackageSlip.body.default,
                        },
                        {
                            key: 'shipping-package-slip:footer',
                            name: this.$t('Footer'),
                            type: 'code-editor:twig',
                            disabled: shippingPackageSlip.footer.partial !== undefined ? false : true,
                            default: shippingPackageSlip.footer.default,
                            template: shippingPackageSlip.footer.partial !== undefined
                                ? shippingPackageSlip.footer.partial
                                : shippingPackageSlip.footer.default,
                        }
                    ]
                })

                // packing list macros

                templates.push({
                    key: 'shipping-package-slip-macros',
                    name: 'Packing List Macros',
                    icon: 'fa-solid fa-clone',
                    fields: [
                        {
                            key: 'shipping-package-slip:articles',
                            name: this.$t('Articles Table'),
                            type: 'code-editor:twig',
                            disabled: shippingPackageSlip.articles.partial !== undefined ? false : true,
                            default: shippingPackageSlip.articles.default,
                            template: shippingPackageSlip.articles.partial !== undefined
                                ? shippingPackageSlip.articles.partial
                                : shippingPackageSlip.articles.default,
                        },
                    ]
                })

                // stock report

                defaults['article-stock-report:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['article-stock-report:header'] = letterHeaderPartial

                defaults['article-stock-report:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['article-stock-report:footer'] = letterFooterPartial

                const stockReport = {
                    style: {
                        partial: _.get(overrides, 'article-stock-report:style'),
                        default: _.get(defaults, 'article-stock-report:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'article-stock-report:header'),
                        default: _.get(defaults, 'article-stock-report:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'article-stock-report:body'),
                        default: _.get(defaults, 'article-stock-report:body', '').trim(),
                    },
                    table: {
                        partial: _.get(overrides, 'article-stock-report:table'),
                        default: _.get(defaults, 'article-stock-report:table', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'article-stock-report:footer'),
                        default: _.get(defaults, 'article-stock-report:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'article-stock-report',
                    name: 'Stock Report',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'article-stock-report:style',
                            name: this.$t('CSS'),
                            type: 'code-editor:css',
                            disabled: stockReport.style.partial !== undefined ? false : true,
                            default: stockReport.style.default,
                            template: stockReport.style.partial !== undefined
                                ? stockReport.style.partial
                                : stockReport.style.default,
                        },
                        {
                            key: 'article-stock-report:header',
                            name: this.$t('Letter Head'),
                            type: 'code-editor:twig',
                            disabled: stockReport.header.partial !== undefined ? false : true,
                            default: stockReport.header.default,
                            template: stockReport.header.partial !== undefined
                                ? stockReport.header.partial
                                : stockReport.header.default,
                        },
                        {
                            key: 'article-stock-report:body',
                            name: this.$t('Body'),
                            type: 'code-editor:twig',
                            disabled: stockReport.body.partial !== undefined ? false : true,
                            default: stockReport.body.default,
                            template: stockReport.body.partial !== undefined
                                ? stockReport.body.partial
                                : stockReport.body.default,
                        },
                        {
                            key: 'article-stock-report:footer',
                            name: this.$t('Footer'),
                            type: 'code-editor:twig',
                            disabled: stockReport.footer.partial !== undefined ? false : true,
                            default: stockReport.footer.default,
                            template: stockReport.footer.partial !== undefined
                                ? stockReport.footer.partial
                                : stockReport.footer.default,
                        }
                    ]
                })

                // stock report macros

                templates.push({
                    key: 'article-stock-report-macros',
                    name: 'Stock Report Macros',
                    icon: 'fa-solid fa-clone',
                    fields: [
                        {
                            key: 'article-stock-report:table',
                            name: this.$t('Articles Table'),
                            type: 'code-editor:twig',
                            disabled: stockReport.table.partial !== undefined ? false : true,
                            default: stockReport.table.default,
                            template: stockReport.table.partial !== undefined
                                ? stockReport.table.partial
                                : stockReport.table.default,
                        },
                    ]
                })

                // inventory protocol

                defaults['inventory-protocol:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['inventory-protocol:header'] = letterHeaderPartial

                defaults['inventory-protocol:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['inventory-protocol:footer'] = letterFooterPartial

                const inventoryProtocol = {
                    style: {
                        partial: _.get(overrides, 'inventory-protocol:style'),
                        default: _.get(defaults, 'inventory-protocol:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'inventory-protocol:header'),
                        default: _.get(defaults, 'inventory-protocol:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'inventory-protocol:body'),
                        default: _.get(defaults, 'inventory-protocol:body', '').trim(),
                    },
                    logs: {
                        partial: _.get(overrides, 'inventory-protocol:logs'),
                        default: _.get(defaults, 'inventory-protocol:logs', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'inventory-protocol:footer'),
                        default: _.get(defaults, 'inventory-protocol:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'inventory-protocol',
                    name: 'Inventory Protocol',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'inventory-protocol:style',
                            name: this.$t('CSS'),
                            type: 'code-editor:css',
                            disabled: inventoryProtocol.style.partial !== undefined ? false : true,
                            default: inventoryProtocol.style.default,
                            template: inventoryProtocol.style.partial !== undefined
                                ? inventoryProtocol.style.partial
                                : inventoryProtocol.style.default,
                        },
                        {
                            key: 'inventory-protocol:header',
                            name: this.$t('Letter Head'),
                            type: 'code-editor:twig',
                            disabled: inventoryProtocol.header.partial !== undefined ? false : true,
                            default: inventoryProtocol.header.default,
                            template: inventoryProtocol.header.partial !== undefined
                                ? inventoryProtocol.header.partial
                                : inventoryProtocol.header.default,
                        },
                        {
                            key: 'inventory-protocol:body',
                            name: this.$t('Body'),
                            type: 'code-editor:twig',
                            disabled: inventoryProtocol.body.partial !== undefined ? false : true,
                            default: inventoryProtocol.body.default,
                            template: inventoryProtocol.body.partial !== undefined
                                ? inventoryProtocol.body.partial
                                : inventoryProtocol.body.default,
                        },
                        {
                            key: 'inventory-protocol:footer',
                            name: this.$t('Footer'),
                            type: 'code-editor:twig',
                            disabled: inventoryProtocol.footer.partial !== undefined ? false : true,
                            default: inventoryProtocol.footer.default,
                            template: inventoryProtocol.footer.partial !== undefined
                                ? inventoryProtocol.footer.partial
                                : inventoryProtocol.footer.default,
                        }
                    ]
                })

                // inventory protocol macros

                templates.push({
                    key: 'inventory-protocol-macros',
                    name: 'Inventory Protocol Macros',
                    icon: 'fa-solid fa-clone',
                    fields: [
                        {
                            key: 'inventory-protocol:logs',
                            name: this.$t('Logs Table'),
                            type: 'code-editor:twig',
                            disabled: inventoryProtocol.logs.partial !== undefined ? false : true,
                            default: inventoryProtocol.logs.default,
                            template: inventoryProtocol.logs.partial !== undefined
                                ? inventoryProtocol.logs.partial
                                : inventoryProtocol.logs.default,
                        },
                    ]
                })

                if (this.form.extensions.find(extension => extension.key === 'shop:point-of-sale')) {

                    // POS cash report

                    defaults['cash-report:header'] = defaults['pdf-letter:header']
                    if (letterHeaderPartial) defaults['cash-report:header'] = letterHeaderPartial

                    defaults['cash-report:footer'] = defaults['pdf-letter:footer']
                    if (letterFooterPartial) defaults['cash-report:footer'] = letterFooterPartial

                    const cashReport = {
                        style: {
                            partial: _.get(overrides, 'cash-report:style'),
                            default: _.get(defaults, 'cash-report:style', '').trim(),
                        },
                        header: {
                            partial: _.get(overrides, 'cash-report:header'),
                            default: _.get(defaults, 'cash-report:header', '').trim(),
                        },
                        body: {
                            partial: _.get(overrides, 'cash-report:body'),
                            default: _.get(defaults, 'cash-report:body', '').trim(),
                        },
                        logs: {
                            partial: _.get(overrides, 'cash-report:logs'),
                            default: _.get(defaults, 'cash-report:logs', '').trim(),
                        },
                        footer: {
                            partial: _.get(overrides, 'cash-report:footer'),
                            default: _.get(defaults, 'cash-report:footer', '').trim(),
                        }
                    }

                    templates.push({
                        key: 'cash-report',
                        name: 'POS Cash Report',
                        icon: 'fa-solid fa-file-lines',
                        fields: [
                            {
                                key: 'cash-report:style',
                                name: this.$t('CSS'),
                                type: 'code-editor:css',
                                disabled: cashReport.style.partial !== undefined ? false : true,
                                default: cashReport.style.default,
                                template: cashReport.style.partial !== undefined
                                    ? cashReport.style.partial
                                    : cashReport.style.default,
                            },
                            {
                                key: 'cash-report:header',
                                name: this.$t('Letter Head'),
                                type: 'code-editor:twig',
                                disabled: cashReport.header.partial !== undefined ? false : true,
                                default: cashReport.header.default,
                                template: cashReport.header.partial !== undefined
                                    ? cashReport.header.partial
                                    : cashReport.header.default,
                            },
                            {
                                key: 'cash-report:body',
                                name: this.$t('Body'),
                                type: 'code-editor:twig',
                                disabled: cashReport.body.partial !== undefined ? false : true,
                                default: cashReport.body.default,
                                template: cashReport.body.partial !== undefined
                                    ? cashReport.body.partial
                                    : cashReport.body.default,
                            },
                            {
                                key: 'cash-report:footer',
                                name: this.$t('Footer'),
                                type: 'code-editor:twig',
                                disabled: cashReport.footer.partial !== undefined ? false : true,
                                default: cashReport.footer.default,
                                template: cashReport.footer.partial !== undefined
                                    ? cashReport.footer.partial
                                    : cashReport.footer.default,
                            }
                        ]
                    })

                    // cash report macros

                    templates.push({
                        key: 'cash-report-macros',
                        name: 'POS Cash Report Macros',
                        icon: 'fa-solid fa-clone',
                        fields: [
                            {
                                key: 'cash-report:logs',
                                name: this.$t('Logs Table'),
                                type: 'code-editor:twig',
                                disabled: cashReport.logs.partial !== undefined ? false : true,
                                default: cashReport.logs.default,
                                template: cashReport.logs.partial !== undefined
                                    ? cashReport.logs.partial
                                    : cashReport.logs.default,
                            },
                        ]
                    })
                }

                // coupon letter

                defaults['coupon-letter:header'] = defaults['pdf-letter:header']
                if (letterHeaderPartial) defaults['coupon-letter:header'] = letterHeaderPartial

                defaults['coupon-letter:footer'] = defaults['pdf-letter:footer']
                if (letterFooterPartial) defaults['coupon-letter:footer'] = letterFooterPartial

                const couponLetter = {
                    style: {
                        partial: _.get(overrides, 'coupon-letter:style'),
                        default: _.get(defaults, 'coupon-letter:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'coupon-letter:header'),
                        default: _.get(defaults, 'coupon-letter:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'coupon-letter:body'),
                        default: _.get(defaults, 'coupon-letter:body', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'coupon-letter:footer'),
                        default: _.get(defaults, 'coupon-letter:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'coupon-letter',
                    name: 'Coupon',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'coupon-letter:style',
                            name: this.$t('CSS'),
                            type: 'code-editor:css',
                            disabled: couponLetter.style.partial !== undefined ? false : true,
                            default: couponLetter.style.default,
                            template: couponLetter.style.partial !== undefined
                                ? couponLetter.style.partial
                                : couponLetter.style.default,
                        },
                        {
                            key: 'coupon-letter:header',
                            name: this.$t('Letter Head'),
                            type: 'code-editor:twig',
                            disabled: couponLetter.header.partial !== undefined ? false : true,
                            default: couponLetter.header.default,
                            template: couponLetter.header.partial !== undefined
                                ? couponLetter.header.partial
                                : couponLetter.header.default,
                        },
                        {
                            key: 'coupon-letter:body',
                            name: this.$t('Body'),
                            type: 'code-editor:twig',
                            disabled: couponLetter.body.partial !== undefined ? false : true,
                            default: couponLetter.body.default,
                            template: couponLetter.body.partial !== undefined
                                ? couponLetter.body.partial
                                : couponLetter.body.default,
                        },
                        {
                            key: 'coupon-letter:footer',
                            name: this.$t('Footer'),
                            type: 'code-editor:twig',
                            disabled: couponLetter.footer.partial !== undefined ? false : true,
                            default: couponLetter.footer.default,
                            template: couponLetter.footer.partial !== undefined
                                ? couponLetter.footer.partial
                                : couponLetter.footer.default,
                        }
                    ]
                })

                // reset password email

                defaults['reset-password:header'] = defaults['email:header']
                if (emailHeaderPartial) defaults['reset-password:header'] = emailHeaderPartial

                defaults['reset-password:footer'] = defaults['email:footer']
                if (emailFooterPartial) defaults['reset-password:footer'] = emailFooterPartial

                const resetPassword = {
                    style: {
                        partial: _.get(overrides, 'reset-password:style'),
                        default: _.get(defaults, 'reset-password:style', '').trim(),
                    },
                    header: {
                        partial: _.get(overrides, 'reset-password:header'),
                        default: _.get(defaults, 'reset-password:header', '').trim(),
                    },
                    body: {
                        partial: _.get(overrides, 'reset-password:body'),
                        default: _.get(defaults, 'reset-password:body', '').trim(),
                    },
                    footer: {
                        partial: _.get(overrides, 'reset-password:footer'),
                        default: _.get(defaults, 'reset-password:footer', '').trim(),
                    }
                }

                templates.push({
                    key: 'reset-password',
                    name: 'Reset Password',
                    icon: 'fa-solid fa-file-lines',
                    fields: [
                        {
                            key: 'reset-password:style',
                            name: this.$t('Email CSS'),
                            type: 'code-editor:css',
                            disabled: resetPassword.style.partial !== undefined ? false : true,
                            default: resetPassword.style.default,
                            template: resetPassword.style.partial !== undefined
                                ? resetPassword.style.partial
                                : resetPassword.style.default,
                        },
                        {
                            key: 'reset-password:header',
                            name: this.$t('Email Header'),
                            type: 'code-editor:twig',
                            disabled: resetPassword.header.partial !== undefined ? false : true,
                            default: resetPassword.header.default,
                            template: resetPassword.header.partial !== undefined
                                ? resetPassword.header.partial
                                : resetPassword.header.default,
                        },
                        {
                            key: 'reset-password:body',
                            name: this.$t('Email Body'),
                            type: 'code-editor:twig',
                            disabled: resetPassword.body.partial !== undefined ? false : true,
                            default: resetPassword.body.default,
                            template: resetPassword.body.partial !== undefined
                                ? resetPassword.body.partial
                                : resetPassword.body.default,
                        },
                        {
                            key: 'reset-password:footer',
                            name: this.$t('Email Footer'),
                            type: 'code-editor:twig',
                            disabled: resetPassword.footer.partial !== undefined ? false : true,
                            default: resetPassword.footer.default,
                            template: resetPassword.footer.partial !== undefined
                                ? resetPassword.footer.partial
                                : resetPassword.footer.default,
                        },
                    ]
                })
            }

            return templates
        },
        ...mapGetters({
            form: 'settings/form',
            options: 'settings/options',
            settingValues: 'settings/values',
            activeCms: 'activeCms'
        })
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        toggleDefault(useDefault, field) {
            if (!useDefault) {
                this.updateDocumentTemplatePartial({
                    key: field.key,
                    template: field.default,
                })
            } else {
                this.deleteDocumentTemplatePartial(field)
            }
        },
        ...mapMutations({
            updateDocumentTemplatePartial: 'settings/form/updateDocumentTemplatePartial',
            deleteDocumentTemplatePartial: 'settings/form/deleteDocumentTemplatePartial',
        })
    },
    // beforeRouteEnter(to, from, next) {
    //     let cms = _.get(store, 'state.setup.activeCms');
    //
    //     next(vm => {
    //         const settings = _.get(vm.form, 'config.template.settings')
    //             || _.get(vm.activeCms, 'config.template.settings')
    //             || []
    //
    //         if (!settings.find(el => el.key === 'document-templates')) {
    //             next({ name: 'settings-form' });
    //         } else {
    //             next();
    //         }
    //     })
    // }
}
</script>

<style lang="sass" scoped>
.row
    display: flex
    margin-bottom: 12px
    & > span.flex
        width: 100%
        display: flex
        flex-wrap: wrap
        row-gap: 20px

.setting-field
    margin-right: 20px

.col-right
    img
        width: 90%

.el-main.main-slot .el-form .el-card .el-card__body section > .el-row > .el-col-lg-12:first-child:before
    display: none

.icon
    margin-right: 10px
    height: 18px
    width: 18px
    padding: 7px
    // color: #fff
    // background: #474747
    // border: 1px solid #575757
    // border-radius: 2px

.accordion-body
    font-size: 1rem
    // & > .alert:first-child
    //     margin-top: 0
.flex-row
    gap: 2rem
    &.gap-sm
        gap: 0.5rem
    &.justify-center
        justify-content: center
    &.align-center
        align-items: center

hr.no-margin
    margin: 0

strong.name
    font-size: 1.2rem
    color: #333
    font-weight: 400

.document-template-field
    margin-top: 1rem
    margin-bottom: 0
</style>
